import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.grey.grey100}`,
    padding: '6px 7px',
    borderRadius: '16px'
  },
  text: {
    fontSize: '10px',
    fontWeight: 700,
    color: theme.palette.error.error600,
    marginLeft: '5px',
    lineHeight: '120%',
  },
  date: {
    fontSize: '10px',
    fontWeight: 400,
    color: theme.palette.grey.grey700,
    marginLeft: '5px',
    lineHeight: '120%',

  }

}));

export default useStyles;
